<template>
  <div class="shujutongji">
    <div class="opertioncontainer">
      <ul class="optionBox">
        <li>
          <span class="tit">开始时间：</span>
          <div class="inputbox">
            <time-selct :value.sync="startTime"></time-selct>
          </div>
        </li>
        <li>
          <span class="tit">截止时间：</span>
          <div class="inputbox">
            <time-selct :value.sync="endTime"></time-selct>
          </div>
        </li>
      </ul>
      <p class="btnbox">
        <van-button size="small" color="linear-gradient(to bottom, #3de9a9, #23cc9a)" @click="checkdata"><span class="pdl20 pdr20">查询</span></van-button>
        <!-- <span class="icon_btn" @click="checkdata"></span> -->
      </p>
    </div>
    <div class="contentbox">
      <div class="container">
        <ul class="topBox">
          <li>
            <span class="td1">域名</span>
            <span class="td2">访问</span>
            <span class="td3">登录</span>
            <span class="td4">充值</span>
            <span class="td5">收入</span>

          </li>
        </ul>
        <van-divider dashed v-if="list.length ===0">暂无数据</van-divider>
        <div class="tableCont" v-else>
          <van-pull-refresh class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
              <ul>
                <li v-for="(item,i) in list" :key="'list'+i">
                  <span class="td1">
                    <i class="time">{{item.domain.split(' ')[0]}} <br><em>{{item.domain.split(' ')[1]}}</em></i>
                  </span>
                  <span class="td2">{{item.visitNumber}}</span>
                  <span class="td3">{{item.loginNumber}}</span>
                  <span class="td4">{{item.orderMoney}}</span>
                  <span class="td5">{{item.profit}}</span>
                </li>
              </ul>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeSelct from '../components/timeSelct1';
export default {
  components: {
    timeSelct
  },
  data() {
    return {
      list: [],
      startTime: '',
      endTime: '',
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 20,
      total: 0
    };
  },
  methods: {
    getlist() {
      this.$api.home
        .shujutongji({
          StartTime: this.startTime,
          EndTime: this.endTime,
          uuid: this.$route.query.uuid,
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
        })
        .then((data) => {
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished) {
        return;
      }
      this.getlist();
    },
    // 查询数据
    checkdata() {
      this.loading = false;
      this.finished = false;
      this.refreshing = false;
      this.PageNumber = 1;
      this.list = [];
      this.getlist();
    }
  },
  created() {
    // this.getlist();
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    // 设置起始时间为当天 00:00
    this.startTime = `${year}-${month}-${day} 00:00:00`;
    // 设置结束时间为当天 23:59
    this.endTime = `${year}-${month}-${day} 23:59:59`;
    this.getlist(); // 自动加载数据
  }
};
</script>

<style lang="scss" scoped>
.shujutongji {
  position: relative;
  height: 100%;
  // background: url(../assets/images/bg.jpg) no-repeat center top;
  // background-size: 100% auto;
  padding-top: 183px;
  .opertioncontainer {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    padding-bottom: 20px;
    .optionBox {
      padding-top: 40px;
      li {
        margin-bottom: 15px;
        text-align: center;
        .tit {
          display: inline-block;
          vertical-align: middle;
          font-size: 17px;
          color: #727272;
          width: 88px;
        }
        .inputbox {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
      }
    }
    .btnbox {
      text-align: center;
      .icon_btn {
        display: inline-block;
        width: 100px;
        height: 30px;
        background: url(../assets/images/btns.png) no-repeat center center;
        background-size: 100% auto;
      }
    }
  }
  .contentbox {
    // position: relative;
    height: 100%;
    padding-bottom: 30px;
    margin: 0 15px;  //改动
    // padding-top: 38px;
    // background: #fff;
    text-align: center;
    // border: 1px solid #bfd6fe;
    // border-bottom: none;
    .container {
      position: relative;
      padding-top: 38px;
      background: #fff;
      border: 1px solid #c6c6c6;
      height: 100%;
      background: #fff;
      .topBox {
        position: absolute;
        height: 38px; //新加
        width: 100%;
        top: 0;
        left: 0;
        li {
          display: flex;
          flex-flow: row nowrap;
          span {
            padding: 0 5px;
            height: 38px;
            line-height: 38px;
            font-size: 15px;
            color: #646464;
            font-weight: bold;
            border-right: 1px solid #c6c6c6;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            border-bottom: 1px solid #c6c6c6;
            &.td1 {
              width: 28%;
            }
            &.td2 {
              width: 18%;
            }
            &.td3 {
              width: 18%;
            }
            &.td4 {
              width: 18%;
            }
            &.td5 {
              width: 18%;
              border-right: none;
            }
          }
        }
      }
      .tableCont {
        height: 100%;
        overflow-y: auto;
        // .scrolldiv {
        //   height: 100%;
        // }
        ul {
          li {
            display: flex;
            flex-flow: row nowrap;
            &:nth-child(ODD) {
              background: #dce8fe;
            }
            span {
              padding: 0 5px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              color: #262626;
              // font-weight: bold;
              border-right: 1px solid #c6c6c6;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              word-break: break-all;
              border-bottom: 1px solid #c6c6c6;
              font-size: 12px;
              .time {
                display: block;
                padding-top: 5px;
                line-height: 15px;
                // font-size: 12px;
                em {
                  color: #5b5b5b;
                }
              }
              &.td1 {
                width: 28%;
                white-space: normal;
                line-height: 15px;
                padding-top: 4px;
              }
              &.td2 {
                width: 18%;
              }
              &.td3 {
                width: 18%;
              }
              &.td4 {
                width: 18%;
              }
              &.td5 {
                width: 18%;
                border-right: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
